import { useHistory, useLocation } from 'react-router-dom';
import { Container } from './styled';
import { OptionMenu } from './OptionMenu';
import { FaUsers } from 'react-icons/fa';
// import { RiCustomerService2Fill } from 'react-icons/ri';
import { MdStickyNote2 } from 'react-icons/md';
import { MdModeEdit } from "react-icons/md";
import { FaRegLightbulb } from "react-icons/fa";
import { useAuth } from '../../../../../../contexts/auth';

export function MenuAdmin() {

    const history = useHistory();
    const location = useLocation();
    const { functionality } = useAuth();

    const hasTutorialFunctionality = Array.isArray(functionality)
        ? functionality.includes('tutorial')
        : String(functionality).includes('tutorial');

    const titleMenuUsers = () => {
        return (
            <span className='title--'>
                {`Cadastros`}
                <MdModeEdit />
            </span>
        )
    };
    const titleMenuComments = () => {
        return (
            <span className='title--'>
                {`Anotações`}
                <MdStickyNote2 />
            </span>
        )
    };
    const titleMenuTutorials = () => {
        return (
            <span className='title--'>
                {`Tutoriais e Documentos`}
                <FaRegLightbulb />
            </span>
        )
    };
    const isSelected = (refPathname) => {
        const { pathname } = location;
        return (refPathname === pathname)
    }
    function handleClick(pathname) {
        history.push(pathname);
    };


    return (
        <Container>
            <OptionMenu title={titleMenuUsers()}>
                <li
                    onClick={
                        () => { handleClick(`/admin/registers/list`) }
                    }
                    className={`${(isSelected(`/admin/registers/list`)) ? 'selected' : ''}`}
                >
                    {`Usuários`}
                </li>
                <li
                    onClick={
                        () => { handleClick(`/admin/registers/groups`) }
                    }
                    className={`${(isSelected(`/admin/registers/groups`)) ? 'selected' : ''}`}
                >
                    {`Setores`}
                </li>
                <li
                    onClick={
                        () => { handleClick(`/admin/registers/holidays`) }
                    }
                    className={`${(isSelected(`/admin/registers/holidays`)) ? 'selected' : ''}`}
                >
                    {`Feriados`}
                </li>
            </OptionMenu>
            <OptionMenu title={titleMenuComments()}>
                <li
                    onClick={
                        () => { handleClick(`/admin/comments/categories`) }
                    }
                    className={`${(isSelected(`/admin/comments/categories`)) ? 'selected' : ''}`}
                >
                    {` Categorias`}
                </li>
            </OptionMenu>
            {hasTutorialFunctionality && (
                <OptionMenu title={titleMenuTutorials()}>
                    <li
                        onClick={
                            () => { handleClick(`/admin/tutorials/ViewTutorials`) }
                        }
                        className={`${(isSelected(`/admin/tutorials/ViewTutorials`)) ? 'selected' : ''}`}
                    >
                        {`Tutoriais e Documentos`}
                    </li>
                </OptionMenu>
            )}
        </Container >
    );
}   